<template>
  <div class="signup app-content bg-gray">
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'/news'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.of_news_list")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./news' + NID">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.news_detail")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12 py-2">
            <b-card >
                  <h4 v-html="news.title"></h4>
                  <small class="mgr-10">{{format_day(news)}}</small>
                  <div>
                    <p class="mt-3" v-html='news.description'></p>
                  </div>
            </b-card>
          </div>
          <div class="col-2 mx-auto">
            <router-link :to="'/news'">
              <b-button
                type="button"
                class="mx-1 my-2 btn blue-button"
                style="width:4rem;"
              >
                {{$t("message.back")}}
              </b-button>
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import moment from 'moment';
export default {
  data () {
    return {
      occupation: undefined,
      news: {},
      idToken: localStorage.idToken,
      NID: this.$route.params.NID
    }
  },
  methods: {
    format_day(news){
        if(news != undefined) {
            return moment(news['created_at']).format("YYYY.M.DD")
        }
      },
    fetch_news: function() {
      var lang = ''
      if(this.language == 'kh'){
        lang = 'km'
      }else if(this.language == 'lk'){
        lang = 'si'
      }else{
        lang = this.language
      }
      axios
      .get(process.env.VUE_APP_API + "/news/" + this.NID,{headers: {'Authorization': 'Bearer ' + this.idToken},params: {
          industry_id: this.memberInfo.current_industry,
          lang: lang
        }})
      .then(response => {
        console.log('this is response news',response)
        this.news = response.data

      }).catch(error => {
        console.log('this is error', error)
      })
    },
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.occupation = this.memberInfo.current_industry
    this.fetch_news()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    })
  },
  watch:{
    memberInfo(val){
      this.occupation = val.current_industry
    },
    language(){
      this.fetch_news()
    }
  },
}
</script>

<style scoped lang="scss">
.article_title{
  font-weight: bold;
  font-size: 16px;
}

.news-li{
  list-style: none;
}

</style>
